import React from "react";

import PayoutsList from "PayoutsList";

// Internal tools payout index — full access, can create payouts.
const PayoutList = () => (
  <PayoutsList endpoint="internal/payouts" canCreate={true} showSent={true} />
);

export default PayoutList;
